module.exports = __webpack_public_path__ + "static/img/sangdi6.7beae9f7.jpg";